<template>
  <b-dropdown variant="setting" size="md" no-caret right id="popover-shop-sync">
    <template #button-content>
      <i class="fa fa-cog" aria-hidden="true"></i>
    </template>
    <b-dropdown-text style="width: 240px;">
      Settings
    </b-dropdown-text>
    <b-dropdown-divider></b-dropdown-divider>
    <b-dropdown-text style="width: 240px;">
      <b-row v-if="loading" class="d-flex justify-content-center">
        <b-spinner style="width: 3rem; height: 3rem;" variant="primary" label="Spinning"></b-spinner>
      </b-row>
      <b-row>
        <b-col cols="3" class="sd_col">
          <label class="sd_label">Shop</label>
        </b-col>
        <b-col cols="9">
          <b-form-select @input="refreshProducts" v-model="selected_shop" :options="shopList"></b-form-select>
        </b-col>
      </b-row>
    </b-dropdown-text>
  </b-dropdown>
</template>

<script>
import Shops from "@/mixins/Shops";
import SiteSettings from "@/mixins/SiteSettings";
export default {
  name: "Setting",
  mixins: [Shops, SiteSettings],
  data: () => ({
    loading: false,
    // shops: ["aa", "ss"],
  }),
  computed: {
    selected_shop: {
      get() {
        return this.selected;
      },
      set(data) {
        this.$store.dispatch("shops/fetchShopInfo", data);
        this.$store.dispatch("shops/fetchCashflowData");
      },
    },
    shopList: function () {
      if (this.shops.length) {
        return this.shops.map((item) => ({
          text: item.name,
          value: item,
        }));
      }
      return [];
    },
  },
  methods: {
    refreshProducts() {
      this.$store.dispatch("product/fetchProducts");
    },
    showModal() {
      this.$refs["SettingsModal"].show();
    },
    hideModal() {
      this.$refs["SettingsModal"].hide();
    },
  },
};
</script>

<style scoped>
.returnButton {
  height: 29px;
  width: 62px;
  color: white;
  background: blueviolet;
  border-radius: 17px;
  border: antiquewhite;
}

#table_help {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#table_help td,
#table_help th {
  border: 1px solid #ddd;
  padding: 8px;
}

#table_help tr:nth-child(even) {
  background-color: #f9f9f9;
}

/* #table_help tr:hover {
  background-color: #f9f9f9;
} */

#table_help th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #f9f9f9;
  color: #5f6983;
}

.sd_label {}

.sd_col {
  align-items: center;
}
</style>
